import core from '@bbob/core'
import type { HtmlFragmentDefinition } from '#shared/model/html'
import { postTransformBbCode } from './post-transform-bb-code'
import { preTransformBBCode } from './pre-transform-bb-code'
import { preset } from './preset'

export function parseBbCode(bbCode: string): HtmlFragmentDefinition {
  const preTransformedBbCode = preTransformBBCode(bbCode)
  const plugins = preset()

  const bbCodeTree = core(plugins).process(preTransformedBbCode).raw
  const postTransformedBbCodeTree = postTransformBbCode(bbCodeTree)
  return postTransformedBbCodeTree
}
